import { render, staticRenderFns } from "./TheSidePanel.vue?vue&type=template&id=077ac034&"
import script from "./TheSidePanel.vue?vue&type=script&lang=js&"
export * from "./TheSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports